/* @ngInject */
export default function userTableController(AccountsFactory, $state, ModalService) {
    const vm = this;

    vm.users = [];
    vm.userTableColumns = AccountsFactory.getUserTableColumns();
    vm.pageNumber = 0;
    vm.sortCol = 2;
    vm.sortOrder = 2;
    vm.totalCount = 0;
    vm.loadingUsers = true;

    init();

    /*= =======================================
	 =            Public Functions            =
	 ======================================== */
    vm.switchPage = function (pageNumber) {
        vm.pageNumber = pageNumber - 1;
        getUsers();
    };

    vm.headerClick = function (column) {
        if (column.sort === true) {
            if (column.apiColumnId === vm.sortCol) {
                // Current column that we're sorting by was clicked, change sort order
                vm.sortOrder = (vm.sortOrder === 1) ? 2 : 1;
            } else {
                // Sort by a new column
                vm.sortCol = column.apiColumnId;
                vm.sortOrder = 2;
            }
            vm.pageNumber = 0;
            getUsers();
        }
    };

    vm.addUser = function () {
        const modal = ModalService.launchLgModal({
            templateUrl: 'app/accounts/user/addUser/addUser.html',
            windowClass: 'add-user',
            controller: 'AddUserController',
            controllerAs: 'addUser',
            size: 'full-screen',
        });

        modal.result.then((result) => {
            if (result === true) {
                //				console.log("do we need to do anything here like update the usertable to include the new user?");
                getUsers();
            }
            ModalService.closeLgModal();
        });
    };

    vm.viewUser = function (user) {
        $state.go('accounts', { accountPage: 'users', accountId: user.ContractorUserId });
        AccountsFactory.isEditUser = true;
    };
    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */
	 function init() {
	 	getUsers();
	 }

	 function getUsers() {
	 	vm.loadingUsers = true;

        const params = {
            PageNumber: vm.pageNumber,
            PageSize: 20,
            SortCol: vm.sortCol,
            SortOrder: vm.sortOrder,
        };

        AccountsFactory.getUsers(params).then((response) => {
            vm.users = response.data.Data.Users;
            vm.totalCount = response.data.Data.TotalCount;
            vm.loadingUsers = false;
        });
    }
    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/accounts/user/userTableController.js